/**
 * Feature Flags Configuration
 * Single source of truth for all feature flags
 */

interface FeatureFlags {
    /** Enable using pre-calculated gold table for spark chart data */
    sparkChartBundle: boolean;
    /** Enable Market-wide Leaderboard spark type filter option */
    marketWideLeaderboard: boolean;
}

const parseFeatureFlags = (): FeatureFlags => {
    return {
        sparkChartBundle: import.meta.env.REACT_APP_SPARK_CHART_BUNDLE === 'true',
        marketWideLeaderboard: import.meta.env.REACT_APP_MARKET_WIDE_LEADERBOARD === 'true',
    };
};

export const featureFlags = parseFeatureFlags();

export const isSparkChartBundleEnabled = (): boolean => featureFlags.sparkChartBundle;
export const isMarketWideLeaderboardEnabled = (): boolean => featureFlags.marketWideLeaderboard;
export class FeatureDisabledError extends Error {
    constructor(featureName: string) {
        super(`Feature "${featureName}" is not enabled`);
        this.name = 'FeatureDisabledError';
    }
}
